import { render, staticRenderFns } from "./CustomerCustomerMessage.vue?vue&type=template&id=20b0f782"
import script from "./CustomerCustomerMessage.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports